import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CHAIN } from '../chain/config';

// /contact — the form composes an email to the foundation; the side cards
// route common questions to the right place.
export default function Contact() {
    const [form, setForm] = useState({ name: '', email: '', topic: 'Order support', message: '' });
    const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

    const submit = (e) => {
        e.preventDefault();
        const body = encodeURIComponent(`Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`);
        const subject = encodeURIComponent(`[BirrPlug] ${form.topic}`);
        window.location.href = `mailto:birrcoin28@gmail.com?subject=${subject}&body=${body}`;
    };

    return (
        <div className="bp-contact-page container">
            <div className="bp-sec-head" style={{ textAlign: 'center' }}>
                <span className="bp-sec-label">SUPPORT</span>
                <h2 className="bp-sec-title">Contact BirrPlug</h2>
                <p className="bp-join-lede">Questions about an order, your wallet, or selling on BirrPlug? Send us a message and we'll get back to you.</p>
            </div>

            <div className="bp-contact-grid">
                <form className="bp-contact-form" onSubmit={submit}>
                    <div className="bp-field-row">
                        <div className="bp-field">
                            <label>Your name</label>
                            <input className="bp-auth-input" value={form.name} onChange={set('name')} placeholder="How should we address you?" required />
                        </div>
                        <div className="bp-field">
                            <label>Reply-to email</label>
                            <input className="bp-auth-input" type="email" value={form.email} onChange={set('email')} placeholder="you@example.com" required />
                        </div>
                    </div>
                    <div className="bp-field">
                        <label>Topic</label>
                        <select className="bp-auth-input" value={form.topic} onChange={set('topic')}>
                            <option>Order support</option>
                            <option>Wallet & payments</option>
                            <option>Selling on BirrPlug</option>
                            <option>Partnerships & press</option>
                            <option>Something else</option>
                        </select>
                    </div>
                    <div className="bp-field">
                        <label>Message</label>
                        <textarea className="bp-auth-input" rows={6} value={form.message} onChange={set('message')} placeholder="Tell us what's going on…" required />
                    </div>
                    <button type="submit" className="bp-btn-primary">Send Message</button>
                </form>

                <aside className="bp-contact-side">
                    <div className="bp-contact-card">
                        <span className="bp-contact-ico">🏬</span>
                        <h4>Want to sell?</h4>
                        <p>Open your shop in minutes — your wallet becomes your payout address.</p>
                        <Link to="/join/business" className="bp-join-selllink">Open your shop →</Link>
                    </div>
                    <div className="bp-contact-card">
                        <span className="bp-contact-ico">🔐</span>
                        <h4>Wallet trouble?</h4>
                        <p>There are no passwords on BirrPlug — your wallet is your login. Keep your recovery phrase safe.</p>
                        <a href="https://birr.foundation/wallet" target="_blank" rel="noreferrer" className="bp-join-selllink">Get BirrWallet →</a>
                    </div>
                    <div className="bp-contact-card">
                        <span className="bp-contact-ico">⛓</span>
                        <h4>Verify a payment</h4>
                        <p>Every BRC payment is public on {CHAIN.name} — check any transaction yourself.</p>
                        <a href={CHAIN.explorerUrl} target="_blank" rel="noreferrer" className="bp-join-selllink">Open the explorer →</a>
                    </div>
                </aside>
            </div>
        </div>
    );
}
